module.exports = __webpack_public_path__ + "static/img/header-bg.0a1f4d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/header-bg.png
// module id = 713
// module chunks = 0 2 4 5 8 10 11 14 15 16 17 18